<template>
  <div class="add-box">
    <ul class="icon-list">
      <li>
        <el-button type="primary" icon="iconfont icon-plus">增加</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-xiugai">修改</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-delet">删除</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-daochu">导出</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-biangeng">变更</el-button>
      </li>
      <li>
        <el-button
          type="primary"
          icon="iconfont icon-wenjianshangchuan"
        >文件上传</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-tuichu">退出</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-zhanghu">账户</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-changepassword">修改密码</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-home">home</el-button>
      </li>
      <li>
        <el-button
          type="primary"
          icon="iconfont icon-chakanxiangqing"
        >查看详情</el-button>
      </li>
      <br>
      <br>
      <br>
      <li>
        <el-button type="primary" icon="iconfont icon-crawler">SQL监控</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-canshu">参数</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-zidianguanli">字典管理</el-button>
      </li>

      <li>
        <el-button type="primary" icon="iconfont icon-dingshi">定时</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-log">日志</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-hi">欢迎</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-iconfontfinish">全部案件</el-button>
      </li>
      <li>
        <el-button
          type="primary"
          icon="iconfont icon-guanliyuanguanli"
        >管理员管理</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-bumenguanli">部门管理</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-liuchengguanli">流程管理</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-caidan">菜单</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-daibanshijian">待办事件</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-jibingku">疾病库</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-jiaoseguanli">角色管理</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-xitongguanli">系统管理</el-button>
      </li>
      <li>
        <el-button type="primary" icon="iconfont icon-anjianzhongxin">案件中心</el-button>
      </li>

      <li>
        <el-button type="primary" icon="iconfont icon-email">发送邮件通知</el-button>
      </li>

      <li>
        <el-button type="primary" icon="iconfont icon-diaochabiao">调查表</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {}
}
</script>

<style>
.icon-list li {
  display: block;
  float: left;
  /* display: inline-block; */
  margin-left: 20px;
  margin-bottom: 20px;
}
</style>
